define('responsive-pitch-fx/lib/workers/PitchShader',['require','exports','module'],function(require,exports,module){

	var regexColor = /(\d+),/g,
        regexNoAlpha = /[^\(]+\(([^\)]+).*/,
        colors = {
        	white 	: 'rgba(255,255,255,1)',
            transparent: "rgba(255, 255, 255, 0)",
            text: "rgba(255, 255, 255, 1)",
            shadow: 'rgba(0,0,0,1)'
        },
        returnWHITE = function(){
        	return colors.white;
        },
        defaultColor = {
        	getPitchColor : returnWHITE,
        	getPitchBallColor : returnWHITE
        };



    function colorShift($0, $1) {
        var shifted = +$1 - 40;
        return (shifted > 0 ? shifted : 0 ) + ',';
    }

    function colorGradShift($0, $1) {
        var shifted = +$1 - 120;
        return (shifted > 0 ? shifted : 0 ) + ',';
    }

    function colorShiftLight($0, $1) {
        var shifted = +$1 + 40;
        return (shifted < 255 ? shifted : 255 ) + ',';
    }

    function noAlpha($0, $1) {
        return "rgb(" + $1.split(',').slice(0, 3).join(',') + ")";
    }

    function alphaShift($0, $1, $2) {
        return ((+$1 - 0.4) + $2);
    }

    function PitchShader(pitch,renderer){
    	if(!pitch || (pitch && !pitch.isPitch)){
    		pitch=defaultColor;
    	}

    	this.renderer=renderer;

        var ballColor = pitch.details.ballColor || pitch.pitch.getPitchBallColor && pitch.pitch.getPitchBallColor() || colors.white,
            trailColor = pitch.details.trailColor || pitch.pitch.getPitchColor && pitch.pitch.getPitchColor() || colors.white;

    	this.fill=trailColor;
    	this.ball=ballColor;
    	this.pathStroke=this.fill;
    	this.ballStroke=this.ball.replace(regexColor,colorShift);
    	this.text=colors.text;
    	this.shadow=colors.shadow;
    	this.gradientStart=this.fill.replace(regexColor,colorGradShift);
    	this.gradientStop=this.fill;
    }
    PitchShader.prototype={

    	getColor : function(){
    		return this.fill;
    	},
    	getBallColor : function(){
    		return this.ballColor;
    	},
    	getGradient  : function(xStart,yStart,xEnd,yEnd){
    		if(this.renderer.isCanvas){
    			var radius= (Math.max(xEnd, yEnd) - this.renderer.scalers.fakeBallSize) * 0.5 / this.renderer.scalers.canvasDensity,
					grad=this.renderer.gtx_bg.createRadialGradient(xStart, yStart, 0, xEnd, yEnd, radius);

    			grad.addColorStop(0, this.gradientStart);
	    		grad.addColorStop(0.25,this.gradientStop);

    			return grad;
    		}
    		return this.fill;
    	}
    }
    return PitchShader;
});

